jQuery(function ( $ ) {

    $('.news_block_item__image.video').append('<div class="play"></div>');

    $(document).on('click', '.news_block_item__image.video .play', function () {
        var block = $(this).closest('.news_block_item__image'),
            link  = block.attr('data-videolink'),
            type  = block.attr('data-vtype');

        make_video(block, type, link)
    });


    $(document).on('click', '.single_video', function () {
        var block = $(this),
            link  = block.attr('data-videolink'),
            type  = block.attr('data-vtype');

        make_video(block, type, link)
    });


    function make_video( block, type, link ) {

        if (type === 'cloud') {
            block.html('<video autoplay="autoplay" controls preload="none" width="100%" <source src="' + link +
                '/download" type="video/mp4"></video>');
            block.addClass('video_played');
        }
        else if ( type === 'vimeo' ) {
            var regExp = /^.*(vimeo\.com\/)((channels\/[A-z]+\/)|(groups\/[A-z]+\/videos\/))?([0-9]+)/,
                id = link.match(regExp);

            block.html('<iframe src="https://player.vimeo.com/video/' + id[5] +
                '?autoplay=1&title=0&byline=0&portrait=0" ' +
                'width="100%" height="100%" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>');
            block.addClass('video_played');
        }
        else if ( type === 'vk' ) {
            var regExp = /^.*(?<root>vk\.com|vkvideo\.ru)\/video(?<oid>-?\d+)_(?<id>\d+)/,
                groups = link.match(regExp).groups;

            block.html('<iframe src="https://' + groups.root + '/video_ext.php?oid=' + groups.oid + '&id=' + groups.id + '"' +
                ' width="100%" height="100%" frameborder="0" allowfullscreen="1" allow="autoplay; encrypted-media; fullscreen; picture-in-picture"></iframe>');
            block.addClass('video_played');
        }
        else if ( type === 'youtube' ) {
            block.html('<iframe width="100%" height="100%" src="' + link.replace(/.+\?v=/, "https://www.youtube.com/embed/") +
                '?autoplay=1" frameborder="0" allowfullscreen></iframe>');
            block.addClass('video_played');
        }
    }

});